/**
 * state 的计算属性
 * 
 * @example
 * export const appAdd = state => {
 *   return state.appAdded;
 * }
 */ 

export const appAdd = state => {
  return state.appAdded;
}